const NUMBERED_EXAM_LINE_RE = /^(\s*)(\d+)\.\s+(.+)$/;

/** Remove "1. ", "2. " etc. das linhas de exames (texto plano ou HTML com ol/li). */
export function formatExamOrderBodyWithoutNumbering(raw: string): string {
  if (!raw?.trim()) return '';

  if (/<(?:ol|li)\b/i.test(raw)) {
    let html = String(raw)
      .replace(/<ol[^>]*>/gi, '')
      .replace(/<\/ol>/gi, '')
      .replace(/<li[^>]*>/gi, '<div>')
      .replace(/<\/li>/gi, '</div>');
    html = html.replace(/(<div[^>]*>)(\d+)\.\s*/gi, '$1');
    return html;
  }

  return String(raw)
    .split('\n')
    .map((line) => {
      const match = line.match(NUMBERED_EXAM_LINE_RE);
      return match ? `${match[1]}${match[3]}` : line;
    })
    .join('\n');
}

/** Converte um template estruturado de pedido de exame em texto para impressos/evolução. */
export function buildExamOrderTemplateBodyText(template: any): string {
  const lines: string[] = [];

  if (template.default_clinical_indication) {
    lines.push(`Indicação clínica: ${template.default_clinical_indication}`);
    lines.push('');
  }

  if (template.default_diagnosis) {
    const code = template.default_diagnosis_code ? ` (${template.default_diagnosis_code})` : '';
    lines.push(`Diagnóstico: ${template.default_diagnosis}${code}`);
    lines.push('');
  }

  const items = [...(template.items || [])].sort(
    (a, b) => Number(a.sort_order ?? 0) - Number(b.sort_order ?? 0),
  );

  if (items.length > 0) {
    lines.push('Exames solicitados:');
    items.forEach((it: any) => {
      const name = it.exam_name || it.name || 'Exame';
      const label = it.exam_code ? `${name} (${it.exam_code})` : name;
      lines.push(label);
      if (it.specimen_type) lines.push(`   Material: ${it.specimen_type}`);
      if (it.body_region) lines.push(`   Região: ${it.body_region}`);
      if (it.laterality && it.laterality !== 'Não se aplica') {
        lines.push(`   Lateralidade: ${it.laterality}`);
      }
      if (it.preparation_instructions) lines.push(`   Preparo: ${it.preparation_instructions}`);
      if (it.clinical_justification) lines.push(`   Justificativa: ${it.clinical_justification}`);
    });
    lines.push('');
  }

  if (template.default_special_instructions) {
    lines.push(`Instruções: ${template.default_special_instructions}`);
    lines.push('');
  }

  if (template.default_notes) {
    lines.push(String(template.default_notes));
  }

  return lines.join('\n').trim();
}
